import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { signatureInterceptorsRequest } from "../utils/common";

const deviceUuid = localStorage.getItem("deviceUuid") || uuidv4();
const baseURLText = window.location;
const baseURL = import.meta.env.DEV
  ? "https://inv.lingzifu.cn"
  : baseURLText.origin;

const ipRegex =
  /^(?:https?:\/\/)?(?:www\.)?(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})$/;

const api = axios.create({
  baseURL: ipRegex.test(baseURL)
    ? window.location.hostname
    : `${window.location.protocol}//${baseURL.replace(/^[^.]*/, "web")}`, // 根据环境更改请求地址
  timeout: 5000, // 设置超时时间
  headers: {
    "Content-Type": "application/json",
    orgName: "1595975575091130369",
    deviceType: "WEB",
    deviceUuid: deviceUuid,
    version: "0.1.0"
  }
});
api.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    // config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    // 请求错误时的处理
    return Promise.reject(error);
  }
);
// 根据请求地址添加验证签名
api.interceptors.request.use(signatureInterceptorsRequest);
api.interceptors.response.use(
  (response) => {
    // 对响应数据进行处理
    return response.data;
  },
  (error) => {
    // 响应错误时的处理
    return Promise.reject(error);
  }
);
export { api };

